export const isFFLoaded = state => state.ffLoaded;
export const isTemplatesViewEnabled = state => state.featureFlags.isTemplatesViewEnabled;
export const isIssuesEnabled = state => state.featureFlags.isIssuesEnabled;
export const isQualityIssuesEnabled = state => state.featureFlags.isQualityIssuesEnabled;
export const isMinimalTableColumns = state => state.featureFlags.isMinimalTableColumns;
export const showProjectViewCreateButton = state => state.featureFlags.showProjectViewCreateButton;
export const getArePushpinSnapshotsEnabled = state => state.featureFlags.enablePushpinSnapshots;
